<template>
    <div class="row">
        <!-- Project List -->
        <div class="col-2">
            <h6><fa-icon icon="project-diagram" /> Projects</h6>
            <div><a href="javascript:;" @click="showCreateProject=!showCreateProject"><fa-icon icon="plus-square" /></a></div>

            <div v-if="showCreateProject" class="row no-gutters">
                <div class="col-10">
                    <input class="form-control form-control-sm" type="text" placeholder="Project Name" v-model="projectName" @input="err001=''" @keyup.enter="newProject()" />
                    <span v-if="err001" class="badge text-danger">{{ err001 }}</span>
                </div>
                <div class="col-2">
                    <a href="javascript:;" class="btn btn-sm text-danger" @click="showCreateProject=!showCreateProject"><fa-icon icon="ban" /></a>
                </div>
            </div>

            <div class="row no-gutters" v-for="(project, idx) in projects" :key="project.id">
                <div class="project-name col-7" :class="{selected:projectSelected===project.id}" @click="selectProject(idx)">
                    <fa-icon v-if="projectSelected===project.id" icon="caret-right" />
                    {{ project.name }}
                </div>
                <div class="col-3">
<!--                    <fa-icon icon="percentage" />50-->
                </div>
                <div class="col-2">
                    <a href="javascript:;" class="text-danger" @click="removeProject(idx)"><fa-icon icon="trash" /></a>
                </div>
            </div>
        </div>

        <!-- Project Details -->
        <div class="col-3">
            <div class="form-group row">
                <label for="name" class="col-2 col-form-label">Name:</label>
                <div class="col-9">
                    <input class="form-control form-control-sm" id="name" type="text" v-model="tmpProject.name" :disabled="projectSelected===-1" @input="isChanged=true" />
                </div>
            </div>
            <div class="form-group row">
                <label for="slug" class="col-2 col-form-label">Slug:</label>
                <div class="col-9">
                    <input class="form-control form-control-sm" id="slug" type="text" v-model="tmpProject.slug" :disabled="projectSelected===-1" @input="isChanged=true"/>
                </div>
            </div>
            <div class="form-group row">
                <label for="description" class="col-11 col-form-label">Description:</label>
                <div class="col-11">
                    <textarea class="form-control form-control-sm" v-model="tmpProject.description" :disabled="projectSelected===-1" id="description" rows="12" @input="isChanged=true"></textarea>
                </div>
            </div>
        </div>

        <!-- Tags -->
        <div class="col-7">
            <div class="row">
                <h6>Auto Suggested Tags:</h6>
            </div>
            <div class="row">
                <ul class="list-inline">
                    <li class="list-inline-item" v-for="(tag, idx) in autoTags" :key="idx">
                        <fragment v-if="tmpProject.tags.indexOf(tag)!==-1">
                            <span class="badge">{{ tag }}</span>
                        </fragment>
                        <fragment v-else>
                            <span class="badge badge-warning pointer" @click="attachTag(tag)">{{ tag }}</span>
                        </fragment>
                    </li>
                </ul>
            </div>

            <div class="row">
                <h6>Saved Tags:</h6>
            </div>
            <div class="row">
                <ul class="list-inline">
                    <li class="list-inline-item" v-for="(tag, idx) in tmpProject.tags" :key="idx">
                        <fa-icon icon="backspace" class="pointer" style="vertical-align: middle; color: var(--info);position:relative;top:1px;" @click="detachTag(tag)" /><span class="badge badge-info">{{ tag }}</span>
                    </li>
                </ul>
            </div>

            <div class="row">
                <h6>Actions:</h6>
            </div>
            <div class="row">
                <ul class="list-inline">
                    <li class="list-inline-item"><button class="btn btn-primary btn-sm" @click="saveProject()" :disabled="!isChanged">Apply Changes</button></li>
                    <li class="list-inline-item"><button class="btn btn-primary btn-sm" @click="$router.push({name:'features'})" :disabled="projectSelected===-1">Go to Features</button></li>
                    <li class="list-inline-item"><button class="btn btn-primary btn-sm" @click="$router.push({name:'static-diagram'})" :disabled="projectSelected===-1">Go to Static</button></li>
                    <li class="list-inline-item"><button class="btn btn-primary btn-sm" @click="$router.push({name:'dynamic-diagram'})" :disabled="projectSelected===-1">Go to Dynamic</button></li>
                    <li class="list-inline-item"><button class="btn btn-primary btn-sm" @click="$router.push({name:'tasks'})" :disabled="projectSelected===-1">Go to Tasks</button></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style>
    .project-name:hover {
        cursor: pointer;
    }

    .project-name.selected {
        color: var(--primary);
    }
</style>

<script>
    import slug from 'slug';
    import moment from 'moment';
    import * as ke from 'keyword-extractor';
    import { mapState } from 'vuex';
    import { PROJECT_SET, PROJECT_UNSET, VOCABULARY_RESET } from "../mutation-types";

    export default {
        name: 'home',

        data() {
            return {
                err001: null,
                showCreateProject: false,
                projectName: '',

                projects: [],

                tmpProject: {name: '', slug: '', description: '', tags: []},
                isChanged: false
            }
        },

        computed: {
            ...mapState(['project']),
            projectSelected() {
                return typeof this.project.id === 'undefined' ? -1 : this.project.id;
            },
            autoTags() {
                return ke.extract(this.tmpProject.description, {language: 'english', remove_digits: true, return_changed_case: true, return_chained_words: true, remove_duplicates: true});
            }
        },

        async created() {
            this.projects = await this.$db.projects.orderBy('updated').reverse().toArray();
            this.tmpProject = {...this.project};
        },

        methods: {
            async newProject() {
                try {
                    let id = await this.$db.projects.add({
                        name: this.projectName,
                        slug: slug(this.projectName, {mode: 'rfc3986'}),
                        description: '',
                        tags: [],
                        created: +moment(),
                        updated: +moment()
                    });
                    let project = await this.$db.projects.get(id);
                    this.$store.commit(PROJECT_SET, project);
                    this.projects.unshift(project);

                    this.$store.commit(VOCABULARY_RESET);
                    this.tmpProject = {...project};
                    this.isChanged = false;
                    this.showCreateProject = false;
                } catch (e) {
                    this.err001 = `project "${this.projectName}" might already exist`;
                }
            },

            async removeProject(idx) {
                await this.$db.projects.delete(this.projects[idx].id);
                if (this.projectSelected !== -1 && this.projectSelected === this.projects[idx].id) {
                    this.tmpProject = {name: '', slug: '', description: '', tags: []};
                    this.$store.commit(PROJECT_UNSET);
                    this.$store.commit(VOCABULARY_RESET);
                    this.isChanged = false;
                }
                this.projects.splice(idx, 1);
            },

            async selectProject(idx) {
                let project = this.projects[idx];
                this.$store.commit(PROJECT_SET, project);
                this.tmpProject = {...project};
                await this.$store.dispatch('initApp', {id: project.id, db: this.$db});
                this.isChanged = false;
            },

            async saveProject() {
                await this.$db.projects.update(this.project.id, this.tmpProject);
                let project = await this.$db.projects.get(this.project.id);
                this.$store.commit(PROJECT_SET, project);
                const idx = this.projects.findIndex(v => v.id === project.id);
                this.projects[idx] = project;
                this.isChanged = false;
            },

            attachTag(tag) {
                if (this.tmpProject.tags.indexOf(tag) === -1) {
                    this.tmpProject.tags.push(tag);
                    this.isChanged = true;
                }
            },
            detachTag(tag) {
                let i;
                if ((i = this.tmpProject.tags.indexOf(tag)) !== -1) {
                    this.tmpProject.tags.splice(i, 1);
                    this.isChanged = true;
                }
            }
        }
    }
</script>
